module.exports = __webpack_public_path__ + "static/media/coin.b6bd0757.png";